import { IconProps } from '../icon';

export function TacheIcon(props: IconProps) {
  return (
    <svg
      id="Tâches"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="23.048"
      viewBox="0 0 40 23.048"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_313"
            data-name="Rectangle 313"
            width="40"
            height="23.048"
            fill="#b9bec4"
          />
        </clipPath>
        <clipPath id="clipPath-3">
          <rect
            id="Rectangle_300"
            data-name="Rectangle 300"
            width="4.924"
            height="4.924"
            fill="#b9bec4"
          />
        </clipPath>
        <clipPath id="clipPath-4">
          <rect
            id="Rectangle_301"
            data-name="Rectangle 301"
            width="23.846"
            height="4.924"
            fill="#b9bec4"
          />
        </clipPath>
        <clipPath id="clipPath-5">
          <rect
            id="Rectangle_303"
            data-name="Rectangle 303"
            width="6.997"
            height="4.913"
            fill="#b9bec4"
          />
        </clipPath>
      </defs>
      <g id="Groupe_573" data-name="Groupe 573" clipPath="url(#clipPath)">
        <g id="Groupe_557" data-name="Groupe 557">
          <g id="Groupe_556" data-name="Groupe 556" clipPath="url(#clipPath)">
            <g id="Groupe_541" data-name="Groupe 541" opacity="0.3">
              <g id="Groupe_540" data-name="Groupe 540">
                <g
                  id="Groupe_539"
                  data-name="Groupe 539"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_226"
                    data-name="Tracé 226"
                    d="M4.924,2.462A2.462,2.462,0,1,1,2.462,0,2.462,2.462,0,0,1,4.924,2.462"
                    fill="#b9bec4"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_544"
              data-name="Groupe 544"
              transform="translate(6.854)"
              opacity="0.5"
            >
              <g id="Groupe_543" data-name="Groupe 543">
                <g
                  id="Groupe_542"
                  data-name="Groupe 542"
                  clipPath="url(#clipPath-4)"
                >
                  <path
                    id="Tracé_227"
                    data-name="Tracé 227"
                    d="M121.084,4.924H100.02a1.391,1.391,0,0,1-1.391-1.391V1.391A1.391,1.391,0,0,1,100.02,0h21.064a1.391,1.391,0,0,1,1.391,1.391V3.533a1.391,1.391,0,0,1-1.391,1.391"
                    transform="translate(-98.629)"
                    fill="#b9bec4"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_549"
              data-name="Groupe 549"
              transform="translate(33.003)"
              opacity="0.8"
            >
              <g id="Groupe_548" data-name="Groupe 548">
                <g
                  id="Groupe_547"
                  data-name="Groupe 547"
                  clipPath="url(#clipPath-5)"
                >
                  <g id="Groupe_546" data-name="Groupe 546">
                    <g
                      id="Groupe_545"
                      data-name="Groupe 545"
                      clipPath="url(#clipPath-5)"
                    >
                      <path
                        id="Tracé_228"
                        data-name="Tracé 228"
                        d="M477.483,4.945a.486.486,0,0,1-.344-.142l-2.085-2.085a.486.486,0,0,1,.687-.687l1.742,1.741,3.6-3.6a.486.486,0,0,1,.687.687l-3.94,3.94a.486.486,0,0,1-.344.142"
                        transform="translate(-474.912 -0.033)"
                        fill="#b9bec4"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="Groupe_552"
              data-name="Groupe 552"
              transform="translate(0 9.328)"
              opacity="0.5"
            >
              <g id="Groupe_551" data-name="Groupe 551">
                <g
                  id="Groupe_550"
                  data-name="Groupe 550"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_229"
                    data-name="Tracé 229"
                    d="M4.924,136.688a2.462,2.462,0,1,1-2.462-2.462,2.462,2.462,0,0,1,2.462,2.462"
                    transform="translate(0 -134.226)"
                    fill="#b9bec4"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_555"
              data-name="Groupe 555"
              transform="translate(6.854 9.328)"
              opacity="0.3"
            >
              <g id="Groupe_554" data-name="Groupe 554">
                <g
                  id="Groupe_553"
                  data-name="Groupe 553"
                  clipPath="url(#clipPath-4)"
                >
                  <path
                    id="Tracé_230"
                    data-name="Tracé 230"
                    d="M121.084,139.15H100.02a1.391,1.391,0,0,1-1.391-1.391v-2.142a1.391,1.391,0,0,1,1.391-1.391h21.064a1.391,1.391,0,0,1,1.391,1.391v2.142a1.391,1.391,0,0,1-1.391,1.391"
                    transform="translate(-98.629 -134.226)"
                    fill="#b9bec4"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g
          id="Groupe_559"
          data-name="Groupe 559"
          transform="translate(33.003 9.328)"
        >
          <g id="Groupe_558" data-name="Groupe 558" clipPath="url(#clipPath-5)">
            <path
              id="Tracé_231"
              data-name="Tracé 231"
              d="M477.483,139.171a.486.486,0,0,1-.344-.142l-2.085-2.085a.486.486,0,0,1,.687-.687L477.483,138l3.6-3.6a.486.486,0,0,1,.687.687l-3.94,3.94a.486.486,0,0,1-.344.142"
              transform="translate(-474.912 -134.259)"
              fill="#b9bec4"
            />
          </g>
        </g>
        <g id="Groupe_572" data-name="Groupe 572">
          <g id="Groupe_571" data-name="Groupe 571" clipPath="url(#clipPath)">
            <g
              id="Groupe_562"
              data-name="Groupe 562"
              transform="translate(0 18.124)"
              opacity="0.3"
            >
              <g id="Groupe_561" data-name="Groupe 561">
                <g
                  id="Groupe_560"
                  data-name="Groupe 560"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_232"
                    data-name="Tracé 232"
                    d="M4.924,263.256a2.462,2.462,0,1,1-2.462-2.462,2.462,2.462,0,0,1,2.462,2.462"
                    transform="translate(0 -260.794)"
                    fill="#b9bec4"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_565"
              data-name="Groupe 565"
              transform="translate(6.854 18.124)"
              opacity="0.5"
            >
              <g id="Groupe_564" data-name="Groupe 564">
                <g
                  id="Groupe_563"
                  data-name="Groupe 563"
                  clipPath="url(#clipPath-4)"
                >
                  <path
                    id="Tracé_233"
                    data-name="Tracé 233"
                    d="M121.084,265.718H100.02a1.391,1.391,0,0,1-1.391-1.391v-2.142a1.391,1.391,0,0,1,1.391-1.391h21.064a1.391,1.391,0,0,1,1.391,1.391v2.142a1.391,1.391,0,0,1-1.391,1.391"
                    transform="translate(-98.629 -260.794)"
                    fill="#b9bec4"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_570"
              data-name="Groupe 570"
              transform="translate(33.003 18.124)"
              opacity="0.8"
            >
              <g id="Groupe_569" data-name="Groupe 569">
                <g
                  id="Groupe_568"
                  data-name="Groupe 568"
                  clipPath="url(#clipPath-5)"
                >
                  <g
                    id="Groupe_567"
                    data-name="Groupe 567"
                    transform="translate(0 0)"
                  >
                    <g
                      id="Groupe_566"
                      data-name="Groupe 566"
                      clipPath="url(#clipPath-5)"
                    >
                      <path
                        id="Tracé_234"
                        data-name="Tracé 234"
                        d="M477.483,265.739a.486.486,0,0,1-.344-.142l-2.085-2.085a.486.486,0,0,1,.687-.687l1.742,1.741,3.6-3.6a.486.486,0,0,1,.687.687l-3.94,3.94a.486.486,0,0,1-.344.142"
                        transform="translate(-474.912 -260.827)"
                        fill="#b9bec4"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default TacheIcon;
